module.exports = __webpack_public_path__ + "img/guide_m_vi.344221a.png";